module.exports = __webpack_public_path__ + "static/media/eduBlue.7e64e160.svg";